import styled from '@emotion/styled';
import { Icon } from '@mdi/react';
import { ClaimResponsibilityType } from '../../api';
import { Variables } from '../base';

const responsibilityColors: Record<ClaimResponsibilityType, string> = {
    [ClaimResponsibilityType.PAYER]: `var(--attention-x-strong, ${Variables.ThemeLight.AttentionInverted5})`,
    [ClaimResponsibilityType.ENTER]: `var(--primary-2x-strong, ${Variables.Colors.b300_l62})`,
    [ClaimResponsibilityType.PROVIDER]: `var(--attention-strong, ${Variables.Colors.sunset500})`,
    [ClaimResponsibilityType.GUARANTOR]: `var(--success-x-strong, ${Variables.Colors.subG20})`,
    [ClaimResponsibilityType.NONE]: `var(--success-x-strong, ${Variables.Colors.subG20})`,
    [ClaimResponsibilityType.UNKNOWN]: `var(--neutral-x-strong, ${Variables.Colors.n70})`,
};

export const Status = styled.span<{ responsibility?: ClaimResponsibilityType }>`
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font: 600 13px/1 var(--font-sans, Calibre, sans-serif);
    text-transform: uppercase;
    letter-spacing: 0.05em;
    white-space: nowrap;
    color: ${({ responsibility }) =>
        responsibility ? responsibilityColors[responsibility] : responsibilityColors[ClaimResponsibilityType.UNKNOWN]};
`;

export const StatusIcon = styled(Icon)`
    width: 14px;
    height: 14px;
    flex-shrink: 0;
    fill: currentColor;
`;
